import {
  CheckboxProps,
  Checkbox as OriginalCheckbox,
} from '@agro1desenvolvimento/react-components';
import { classNames } from 'primereact/utils';
import { ReactElement } from 'react';
import WithController from '../with-controller';

const Checkbox = WithController<PropTypes, boolean>(
  ({
    className,
    field,
    fieldState,
    formState: _formState,
    label,
    containerClassName,
    triggerDependencies,
    ...props
  }) => (
    <div className={classNames('flex-row', containerClassName)}>
      <OriginalCheckbox
        {...props}
        inputId={field.name}
        name={field.name}
        inputRef={field.ref}
        checked={field.value}
        onBlur={field.onBlur}
        onChange={(event) => {
          field.onChange(event.checked);
          triggerDependencies();
        }}
        className={classNames({ 'p-invalid': fieldState.error }, className)}
      />
      <label htmlFor={field.name} className="ml-2">
        {label}
      </label>
    </div>
  ),
);

type OmittedProps =
  | 'inputId'
  | 'name'
  | 'inputRef'
  | 'checked'
  | 'onBlur'
  | 'onChange';

type PropTypes = Omit<CheckboxProps, OmittedProps> & {
  label?: ReactElement | string | number;
  withErrorMessage?: boolean;
  containerClassName?: string;
};

export default Checkbox;
